import { render } from "./Support.vue?vue&type=template&id=48ad24a6&scoped=true"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"

import "./Support.vue?vue&type=style&index=0&id=48ad24a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48ad24a6"

export default script